export default __webpack_public_path__ + "static/media/capex-thop-small.c1a75c68.png";